import { useRouter } from "next/router";
import { useEffect } from "react";
import { PaymentResult } from "../types";
import { SelectablePaymentMethodEnum } from "config/site";
import { useWebTranslation } from "translations";

const useInitStripe = ({
  handleSetupResult,
  handleUrlMatch,
}: {
  handleSetupResult: (result: PaymentResult) => Promise<void>;
  handleUrlMatch: (
    matchPaymentMethod?:
      | SelectablePaymentMethodEnum.Trustly
      | SelectablePaymentMethodEnum.TrustlyMdd
  ) => void;
}): void => {
  const { t } = useWebTranslation();
  const { query, isReady } = useRouter();

  useEffect(() => {
    if (isReady) {
      const tddResult = query.trustly_result;
      const mddResult = query.trustly_mdd_result;
      const result = tddResult || mddResult;

      if (result) {
        const paymentMethod = mddResult
          ? SelectablePaymentMethodEnum.TrustlyMdd
          : SelectablePaymentMethodEnum.Trustly;

        handleUrlMatch(paymentMethod);

        (async () => {
          await handleSetupResult({
            error:
              result === "failure"
                ? {
                    message: t("add_direct_debit.error"),
                  }
                : null,
            paymentMethodSetupId: null,
            paymentMethod,
          });
        })();
      } else {
        handleUrlMatch();
      }
    }
  }, [isReady, query]);
};

export default useInitStripe;
